<template>
  <v-chip :color="color" size="small" variant="tonal" label class="font-weight-medium">{{ label }}</v-chip>
</template>

<script>
import { statusLabel, statusColor } from '@/utils/qaFormat';

export default {
  name: 'QaStatusChip',
  props: {
    // Q9 — นอกจากผลตัดสิน (pass/borderline/fail) chip ตัวนี้แสดงสถานะการประเมินด้วย
    // (pending/not-evaluated/skipped/failed — ป้าย/สีอยู่ใน qaFormat.js ที่เดียว)
    // ⚠️ เลิก required — เคสที่ยังไม่ประเมินไม่มีสถานะให้ส่ง · default เป็น not-evaluated
    //    เพื่อให้ค่าว่างอ่านว่า "ยังไม่ประเมิน" ไม่ใช่ chip เปล่าที่ดูเหมือนบั๊ก
    status: { type: String, default: 'not-evaluated' },
  },
  computed: {
    label() {
      return statusLabel(this.status);
    },
    color() {
      return statusColor(this.status);
    },
  },
};
</script>
